/**
 * AdminSubscriptions.ts (InstaLOD GmbH)
 *
 * Copyright © 2023 InstaLOD GmbH - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * This file and all its contents are proprietary and confidential.
 *
 * Maintained by Rafael Rodrigues, 2023
 *
 * @file AdminSubscriptions.ts
 * @author Rafael Rodrigues
 * @copyright 2023 InstaLOD GmbH. All rights reserved.
 * @section License
 */

import { BASE_API_URL } from '../../Config';
import { HttpClient } from '@abstract/abstractwebcommon-client/utils/HttpClient';
import { createLog } from '../Logs';
import { IAPIEntityResponse } from '@abstract/abstractwebcommon-shared/interfaces/api';
import { defaultTableLimit } from '@abstract/abstractwebcommon-client/Constants';
import { ISubscription } from '@abstract/abstractwebcommon-shared/interfaces/ecommerce/Subscription';
import { paginationRequest } from '@abstract/abstractwebcommon-client/Pagination/paginationRequest';

const httpClient = new HttpClient(BASE_API_URL, createLog);

const baseURLPath: string = '/subscriptions/admin/';

/**
 * Get all subscriptions service.
 * @param skip Skip value for pagination.
 * @param limit Limit value for pagination.
 * @param searchTerm Search term to find specific record.
 * @param sort Sort field and sort order of a field to find specific record.
 * @param returns Promise<IAPIEntityResponse<ISubscription[]>>.
 */
export const getAllSubscriptions = (
  skip = 0,
  limit = defaultTableLimit,
  searchTerm = '',
  sort = {
    sortField: 'createdAt',
    sortOrder: -1
  },
  filter: Record<string, any>
): Promise<IAPIEntityResponse<ISubscription[]>> => {
  const url = paginationRequest(`get/all`, {
    skip,
    limit,
    searchTerm,
    filter
  });
  return httpClient.post(`${baseURLPath}${url}`, { sort });
};
